/* Cartman's Blender turntable, baked once. No WebGL or animation-frame loop. */
(() => {
  if (customElements.get('ombre-rotating-logo')) return;
  const logos = new Set();
  const sprites = new Map();
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  let paused = false;
  try { paused = localStorage.getItem('ombre-logo-paused') === 'true'; } catch (_) { /* Storage is optional. */ }
  const disabled = () => motion.matches || navigator.connection?.saveData || paused;
  const refresh = () => {
    logos.forEach(logo => logo.update());
    document.querySelectorAll('[data-logo-motion-toggle]').forEach(button => {
      button.hidden = motion.matches || !!navigator.connection?.saveData;
      button.setAttribute('aria-pressed', String(paused));
      button.textContent = paused ? 'Play logo animation' : 'Pause logo animation';
    });
  };
  const decode = url => {
    if (!sprites.has(url)) {
      const image = new Image();
      image.fetchPriority = 'low';
      image.src = url;
      sprites.set(url, image.decode().then(() => url));
    }
    return sprites.get(url);
  };
  class RotatingLogo extends HTMLElement {
    connectedCallback() {
      logos.add(this);
      this.visible = false;
      this.observer = new IntersectionObserver(entries => {
        for (const entry of entries) if (entry.target === this) this.visible = entry.isIntersecting;
        this.update();
      });
      this.observer.observe(this);
      refresh();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      logos.delete(this);
      this.toggleAttribute('data-playing', false);
    }
    update() {
      const playing = this.visible && !document.hidden && !disabled();
      this.toggleAttribute('data-playing', playing && this.hasAttribute('data-ready'));
      if (!playing || this.requested || !this.dataset.sprite) return;
      this.requested = true;
      const load = async () => {
        try {
          const url = await decode(this.dataset.sprite);
          if (!logos.has(this)) return;
          this.querySelector('.on-logo__frames').style.backgroundImage = `url("${url}")`;
          this.setAttribute('data-ready', '');
          this.update();
        } catch (_) { /* Keep the rendered poster if the animation cannot load. */ }
      };
      if (typeof requestIdleCallback === 'function') requestIdleCallback(load, { timeout: 2500 });
      else setTimeout(load, 0);
    }
  }
  customElements.define('ombre-rotating-logo', RotatingLogo);
  document.addEventListener('visibilitychange', refresh);
  motion.addEventListener('change', refresh);
  document.addEventListener('click', event => {
    if (!event.target.closest?.('[data-logo-motion-toggle]')) return;
    paused = !paused;
    try { localStorage.setItem('ombre-logo-paused', String(paused)); } catch (_) { /* Storage is optional. */ }
    refresh();
  });
})();
